import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { GetCompanySuccessResponse } from '../../../../../types/api/get-company-success-response';
import { License } from '../../../../../../licenses/types/api/create-license-success-response';
import { showLoadingAlertMessage } from '../../../../../../../utils/show-loading-alert-message/show-loading-alert-message';
import { networkCall } from '../../../../../../../utils/network-call/network-call';
import { showDefaultErrorMessages } from '../../../../../../../utils/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../../../redux/reducer/alert-message.reducer';
import { AlertMessages } from '../../../../../../../enums/alert-messages.enum';
import { DefaultErrorResponse } from '../../../../../../../types/api/error/default-error-response/default-error-respose.type';
import { ValidationErrorResponseData } from '../../../../../../../types/api/error/validation-error-response-data/validation-error-response-data.type.';
import { tranformAPIValidationErrorToAntDValidationMessage } from '../../../../../../../utils/validation/transform-api-validation-errors-to-antd-validation-messsages';
import { GetLicensesSuccessResponse } from '../../../../../../licenses/types/api/get-licenses-success-response';
import { setOpenKeys, setSelectedMenuItemKeys } from '../../../../../../../redux/reducer/antd-layout-info.reducer';
import { LicenseList } from '../../../../../../licenses/components/license-list/license-list';
import { getImageUrl } from '../../../../../../../utils/image-helper/get-image-url';
import { CMSButton } from '../../../../../../../components/cms/button/cms-button.';

export const AdminCompanyEdit = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const loaderData: any = useLoaderData();
    const [licenses, setLicenses] = useState<License[]>([]);

    const onFinish = async (values: any) => {
        showLoadingAlertMessage();

        const response = await networkCall(`/companies/${ loaderData.companyId }`, {
            method: 'PUT',
            body: {
                name: values.name
            }
        });

        const messageShowed = showDefaultErrorMessages(response);
        if(messageShowed) return;

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (response?.status === 200) {

            alertMessageState.alertMessageText = 'Mentés sikeres.';
            alertMessageState.alertMessageType = 'success';

        } else if (response?.status === 400) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {

                case 1000:
                    const _res: AxiosResponse<DefaultErrorResponse<ValidationErrorResponseData[]>> = response;
                    alertMessageState.alertMessageText = 'Hibásan megadott beviteli mezők.';
                    const validationErrors = tranformAPIValidationErrorToAntDValidationMessage(_res.data.data!);
                    form.setFields(validationErrors);
                    break;

            }

        } else if (response?.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = response;

            switch (res.data.code) {
                case 9000:
                    alertMessageState.alertMessageText = 'A cég nem található.';
                    navigate('/cms/admin/companies');
                    break;
            }

        }

        dispatch(showAlertMessage(alertMessageState));
    }

    useEffect(() => {
        const messageShowed = showDefaultErrorMessages(loaderData.getCompanyResponse);
        if(messageShowed) {
            navigate('/cms/admin/companies');
            return;
        }

        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: AlertMessages.UnknownErrorTryAgain
        };

        if (loaderData.getCompanyResponse.status === 200) {
            const res: AxiosResponse<GetCompanySuccessResponse> = loaderData.getCompanyResponse;
            form.setFieldValue('name', res.data.company.name);

            if (loaderData?.getLicensesResponse?.status === 200) {
                const res: AxiosResponse<GetLicensesSuccessResponse> = loaderData.getLicensesResponse;
                setLicenses(res.data.licenses);
            } else {
                dispatch(clearAlertMessage());
                dispatch(showAlertMessage({
                    alertMessageType: 'error',
                    alertMessageText: 'Hiba a licencek listázása során. Próbálja újra!'
                }));
            }

            return;
        } else if (loaderData.getCompanyResponse?.status === 404) {
            const res: AxiosResponse<DefaultErrorResponse> = loaderData.getCompanyResponse;

            switch (res.data.code) {
                case 5000:
                    alertMessageState.alertMessageText = 'A cég nem található.';
                    navigate('/cms/admin/companies');
                    break;
            }

        }

        dispatch(clearAlertMessage());
        dispatch(showAlertMessage(alertMessageState));
    }, [dispatch, loaderData, form, navigate]);

    useEffect(() => {
        dispatch(setOpenKeys(['admin-companies']));
        dispatch(setSelectedMenuItemKeys(['admin-active-companies']));

        return () => {
            dispatch(setOpenKeys([]));
        };
    }, [dispatch]);

    const handleLicenseDelete = (id: number) => {
        let nextLicenses = JSON.parse(JSON.stringify(licenses)) as typeof licenses;
        nextLicenses = nextLicenses.filter(license => license.id !== id);
        setLicenses(nextLicenses);
    };

    return (
        <>
            <div className="page-title">Cég adatlap</div>
            <Form
                form={form}
                onFinish={onFinish}
                layout='vertical'
            >
    
                <Form.Item
                    label={<b>Cég neve</b>}
                    name='name'
                    rules={[{required: true, message: 'Név megadása kötelező!'}]}
                >
                    <Input className='box-shadow-4-4-8-0 border-0' />
                </Form.Item>
                        
            </Form>

            <LicenseList companyId={loaderData.companyId} licenses={licenses} onDelete={handleLicenseDelete} />

            <div className='mt-4 d-flex justify-content-between'>
                <Link to='/cms/admin/active-companies'>
                    <CMSButton text='Vissza' type='white' iconSrc={getImageUrl('back-icon.png')} />
                </Link>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <CMSButton text='Mentés' iconSrc={getImageUrl('Save-icon.png')} htmlType='submit' onClick={() => form.submit()} />
            </div>
        </>
    );
};